import { AceProjektAceProjektEnumsAceProjektStatuscode, AnfrageDisplayModel, GlobalEnumerationsAceTypphase, GlobalEnumerationsAceXfoundportalobjekt } from "@/api/model-index";
import { AnfrageService } from "@/api/services/anfrage.service";
import { AnfrageContract } from "@/core/models/abstractions/anfrage.contract";
import { I18nService } from "@/core/services/i18nService";
import { PortalContextService } from "@/core/services/portal-context.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { NotificationService } from "@progress/kendo-angular-notification";

@Injectable({
    providedIn: 'root'
})
export class AenderungsantragGuard  {
    protected instance: AnfrageContract | null;

    constructor(protected readonly portalContextService: PortalContextService, protected readonly anfrageService: AnfrageService, protected readonly router: Router) {
        //
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        let id: string = <string>route.params['id'];

        const anfrage = await this.anfrageService.apiAnfrageAnfrageIdGet({ anfrageId: id }).toPromise();
        if (anfrage.objektTyp != GlobalEnumerationsAceXfoundportalobjekt.Projekt || anfrage.projektStatus != AceProjektAceProjektEnumsAceProjektStatuscode.Durchfuhrung || !anfrage.aenderungsantragsPhaseId) {
            this.router.navigate(['/']);
            return Promise.resolve(false);
        }

        this.portalContextService.CurrentAnfrage = anfrage;

        return Promise.resolve(true);
    }
}